import { Input } from '@aon/aon-tws-common-ui';
import { ColHalves } from '@aon/tws-common-ui-questions';
import { InnerSectionContainer } from '@aon/tws-common-ui-questions/build/lib/components/questions/custom-questions';
import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { CustomQuestionPropertyUnderValidation, IValidationCollection } from '../../../models';
import { ActionCreators } from '../../../store/CustomQuestionStore';
import { ValidationCollectionHelper } from '../../../utilities';
import { CustomResponseOptionGroupToggle } from './CustomResponseOptionGroupToggle';

export interface IAutoFilledResponseOptionsProps {
	parentQuestionId?: number;
	responseOptionGroupName?: string;
	validationResults?: IValidationCollection;
}

export const ResponseOptionGroupNameInput = styled(Input).attrs<any>({
	className: 'tws-custom-question-response-option-group',
})`
	&&.tws-custom-question-response-option-group {
		width: 200px;
	}
`;

export const ResponseOptionsWrapper = styled('div').attrs<{}>({
	className: 'tws-custom-response-options-selector',
})`
	margin: 40px 0;
`;

export function AutoFilledResponseOptions(props: IAutoFilledResponseOptionsProps) {
	const { parentQuestionId, responseOptionGroupName, validationResults } = props;
	const validationHelper = new ValidationCollectionHelper<CustomQuestionPropertyUnderValidation>(validationResults);
	const responseOptionGroupNameValidation = validationHelper.GetValidationResultForProperty(
		CustomQuestionPropertyUnderValidation.responseOptionGroupName,
	);
	const dispatch = useDispatch();
	return (
		<>
			<ColHalves
				Col1={
					<InnerSectionContainer className={'tws-response-option-group-name'} label={ContentConstants.CUSTOM_RESPONSE_OPTION_NAME}>
						<ResponseOptionGroupNameInput
							error={
								responseOptionGroupNameValidation &&
								responseOptionGroupNameValidation.errors &&
								responseOptionGroupNameValidation.errors.length > 0
							}
							maxLength={100}
							message={responseOptionGroupNameValidation && responseOptionGroupNameValidation.errors}
							onChange={handleResponseOptionGroupNameChange}
							value={responseOptionGroupName}
						/>
					</InnerSectionContainer>
				}
				Col2={<CustomResponseOptionGroupToggle isDemographic={false} parentQuestionId={parentQuestionId} />}
			></ColHalves>
		</>
	);

	function handleResponseOptionGroupNameChange(changeEvent: React.ChangeEvent<HTMLInputElement>) {
		dispatch(ActionCreators.UpdateCustomResponseOptionGroupName(changeEvent.target.value));
	}
}
